export default "__VITE_ASSET__COJPpt$R__"